import { Box, Button, Stack } from "@mui/material";
import { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";

interface UploadersProps {
  title: string | null;
  subtitle: string | null;
  activateWebcam: () => void;
  onDrop: (acceptedFiles: File[]) => void;
  subImageTextOne: string | null;
  subImageTextTwo: string | null;
  subImageTextMobile: string | null;
  isLoading: boolean;
}

const buttonStyles = {
  height: "52px",
  padding: { sm: "0 32px", xs: "0 8px" },
  textTransform: "none",
};

const Uploaders = ({ activateWebcam, onDrop, isLoading }: UploadersProps) => {
  const isMobile = useIsMobile();

  const [, setIsDraggingOver] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
  });
  const { t } = useTranslation();

  return (
    <Box>
      <Stack direction={isMobile ? "column" : "row"} gap={2}>
        <>
          <div {...getRootProps()} style={{ width: "100%" }}>
            <input {...getInputProps()} />
            <Button
              loadingPosition="start"
              loading={isLoading}
              fullWidth
              variant={isMobile ? "contained" : "secondary"}
              sx={buttonStyles}
            >
              {t(`button.select_photo`, "Select Photo")}
            </Button>
          </div>
        </>
        {isMobile ? null : (
          <div style={{ width: "100%" }}>
            <Button fullWidth onClick={activateWebcam} sx={buttonStyles}>
              {t(`button.take_photo`, "Take Photo")}
            </Button>
          </div>
        )}
      </Stack>
    </Box>
  );
};

export default Uploaders;
